interface BannerRequirements {
  [key: string]: {
    [key: string]: {
      width: number;
      height: number;
    };
  };
}
export const BANNER_DISPLAY_TYPE_MAP = {
  FRONTPAGE: 'FRONTPAGE',
  CAROUSEL: 'CAROUSEL',
  CART: 'CART',
  CART_PRODUCTS_LIST: 'CART_PRODUCTS_LIST',
  CATEGORY: 'CATEGORY',
};

export const BANNER_TYPE_MAP = {
  IMAGE: 'IMAGE',
};

export const BANNERS_REQUIREMENTS: BannerRequirements = {
  [BANNER_DISPLAY_TYPE_MAP.FRONTPAGE]: {
    [BANNER_TYPE_MAP.IMAGE]: {
      width: 1100,
      height: 300,
    },
  },
  [BANNER_DISPLAY_TYPE_MAP.CAROUSEL]: {
    [BANNER_TYPE_MAP.IMAGE]: {
      width: 450,
      height: 250,
    },
  },
  [BANNER_DISPLAY_TYPE_MAP.CART]: {
    [BANNER_TYPE_MAP.IMAGE]: {
      width: 920,
      height: 100,
    },
  },
  [BANNER_DISPLAY_TYPE_MAP.CART_PRODUCTS_LIST]: {
    [BANNER_TYPE_MAP.IMAGE]: {
      width: 920,
      height: 100,
    },
  },
  [BANNER_DISPLAY_TYPE_MAP.CATEGORY]: {
    [BANNER_TYPE_MAP.IMAGE]: {
      width: 1030,
      height: 120,
    },
  },
};
